import React, { useState } from "react";
import TermsModal from "./modal_finwell/TermsMdoal";
import { navigate } from "react-big-calendar/lib/utils/constants";
import { useNavigate } from "react-router-dom";

const FooterFinwell = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <footer
        className="text-left text-muted small mt-2rem footer-finwell pb-3"
        role="contentinfo"
      >
        <p>
          © {new Date().getFullYear()} PwC US. All rights reserved. PwC US
          refers to the US group of member firms and may sometimes refer to the
          PwC network. Each member firm is a separate legal entity.
        </p>
        <div className="links-footer">
          <a
            href="https://privacyhub.pwc.com/us/en/financial-wellness/privacy-policy.html"
            target="_blank"
          >
            Privacy policy
          </a>
          {/* <a href="#">Cookie notice</a> */}
          <a href="#" onClick={() => setShow(true)}>
            Terms and conditions
          </a>
          <a href="#" onClick={() => {navigate("/help")}}>
            Help Center
          </a>
          <a href="" onClick={() => {navigate("/coaching")}}>
            Coaching
          </a>
          {/* <a href="#">Customize cookie settings</a> */}
        </div>
      </footer>
      <TermsModal show={show} setShow={setShow} />
    </>
  );
};

export default FooterFinwell;
